export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full lg:max-w-md">
            <div className="relative w-full h-52 md:h-64 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20newsroom%20with%20multiple%20screens%20displaying%20trending%20content%20in%20Chinese%2C%20warm%20amber%20and%20crimson%20ambient%20lighting%2C%20editorial%20workspace%20atmosphere%2C%20professional%20yet%20dynamic%20setting%2C%20soft%20focus%20background%2C%20clean%20aesthetic%2C%20warm%20tones%2C%20cinematic%20composition&width=800&height=520&seq=about-platform&orientation=landscape"
                alt="网红爆料平台介绍"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.classList.add('hidden');
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 to-transparent"></div>
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">关于我们</h2>
            </div>

            <div className="space-y-4">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                <strong className="font-semibold text-foreground-900">网红爆料</strong>是专注追踪网红内幕与争议事件的头部信息平台。我们每日深扒网红爆料事件最新瓜、网红大事件与热门争议话题，为全网吃瓜群众提供最及时、最全面的网红爆料合集。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                从直播带货翻车到人设崩塌，从地下恋情曝光到平台算法揭秘，我们的内容覆盖网红八卦的每一个角落。团队由资深娱乐记者和数据分析师组成，确保每条爆料都有据可查，每份吃瓜都新鲜热辣。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              {[
                { num: '10万+', label: '日活读者' },
                { num: '500+', label: '追踪网红' },
                { num: '24h', label: '实时更新' },
              ].map((d) => (
                <div key={d.label} className="text-center px-4 py-3 bg-background-50 rounded-lg border border-secondary-200/60">
                  <div className="text-lg md:text-xl font-heading font-bold text-primary-500">{d.num}</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">{d.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}